import { useContext } from 'react';

import { SelectedQuoteVariantContext } from '../context/SelectedQuoteVariantContext';

export const useSelectedQuoteVariant = () => useContext(SelectedQuoteVariantContext);
